import { Injectable } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class BonusService {
  public customer: CustomerModel;
  private promoDetailInfo: { id: string ; listType?: string};
  private reloadPromoList = false;

  constructor(
    private webservices: WebservicesService,
    private userSession: UserSessionService,
    private configService: ConfigService
  ) {
    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    )
  }

  callGetBonusOffers() {
    let obj: any = {
      customer_id: this.customer?.customerId,
      session_token: this.userSession?.getSessionToken(),
      clientapp: this.configService.getClientApp()
    }

    return this.webservices.get('rewards/get-bonus-offers', obj);
  }

  callAllGetBonusOffers() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken()
    }

    return this.webservices.get('rewards/get-granted-bonus-offers', obj);
  }

  callBonusOfferOptIn(definition_id: string) {
    let obj: any = {
      campaign_definition_id: definition_id,
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken()
    }

    return this.webservices.post('rewards/bonus-offer-opt-in', obj);
  }

  callGetCustomerCasinoBonusesActive() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken()
    }

    return this.webservices.get('rewards/get-customer-casino-bonuses-active', obj);
  }

  callGetCustomerCasinoBonus(bonus_id) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      bonus_id: bonus_id
    }
    return this.webservices.get('rewards/get-customer-casino-bonus', obj);
  }

  callGetCustomerCasinoBonusesHistory(dateFrom: string, dateTo: string, page?: string) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
    }

    if (dateFrom) {
      obj.date_from = dateFrom;
    }

    if (dateTo) {
      obj.date_to = dateTo;
    }

    if (page) {
      obj.page = page;
    }

    return this.webservices.get('rewards/get-customer-casino-bonuses-history', obj);
  }

  callForfeitBonus(bonus_id: string) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      bonus_id: bonus_id
    }

    return this.webservices.get('rewards/forfeit-bonus', obj);
  }

  callGetBonusDetails(bonus_id: string) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      bonus_id: bonus_id
    }
    return this.webservices.get('rewards/get-bonus-details', obj);
  }

  callValidateBonus(bonus_code: string) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      campaign_code: bonus_code
    }

    return this.webservices.post('rewards/validate-campaign-code', obj);
  }
  
  callRedeemBonus(bonus_code: string) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      bonus_code: bonus_code
    }

    return this.webservices.get('rewards/redeem-bonus', obj);
  }


  callReffererBonus(referrer_code: string) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      referrer_code: referrer_code
    }

    return this.webservices.post('authentication/submit-referrer-code', obj);
  }

  

  callGetBonusFreeSpins() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken()
    }

    return this.webservices.get('rewards/get-bonus-free-spins', obj);
  }


  getPromoDetailInfo() {
    return this.promoDetailInfo;
  }

  setPromoDetailInfo(data) {
    this.promoDetailInfo = data;
  }

  getPromoReload() {
    return this.reloadPromoList;
  }

  setPromoReload(flag:boolean) {
    this.reloadPromoList = flag;
  }

}
